import { Typography } from "@material-tailwind/react";

interface WorkorderOriginDisplayProps {
  origin?: EasyTech.WorkorderOrigin;
  size?: "sm" | "md" | "lg";
}

export const getTranslatedWorkorderOriginLabel = (workorderOrigin?: EasyTech.WorkorderOrigin): string => {
  if (!workorderOrigin) {
    return "-";
  }

  const currentLanguage = localStorage.getItem("i18nextLng") || "en";

  if (workorderOrigin.translations && Array.isArray(workorderOrigin.translations)) {
    const translation = workorderOrigin.translations.find(
      (item) => item.language?.isoCode === currentLanguage
    );

    if (translation && translation.label) {
      return translation.label;
    }
  }

  return workorderOrigin.label || "-";
};

/**
* WorkorderOriginDisplay: Display workorder origin
* @param origin - Origin data
* @param size - Size of the display
*/
export default function WorkorderOriginDisplay({ origin, size = "md" }: WorkorderOriginDisplayProps) {
  if (!origin) {
    return <Typography variant="small" color="blue-gray">-</Typography>;
  }
  
  return (
    <Typography variant="small" color="blue-gray">
      {getTranslatedWorkorderOriginLabel(origin)}
    </Typography>
  );
}
